import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'castnumber' })
export class CastNumberPipe implements PipeTransform {
  transform(n: any): number { return n as number; }
}
